import React from 'react';
export function HowItWorksSection() {
  const phases = [{
    title: 'Dias 1 a 3 — Fase Desincha',
    text: 'Você começa com ajustes simples para reduzir retenção, excesso de sal, gases e sensação de peso.'
  }, {
    title: 'Dias 4 a 14 — Fase Reequilibra',
    text: 'Você introduz refeições mais completas, combinações melhores e hábitos que favorecem digestão e saciedade.'
  }, {
    title: 'Dias 15 a 21 — Fase Mantém',
    text: 'Você aprende como continuar sem voltar ao ciclo de inchaço, culpa e recomeço.'
  }];
  return <section className="py-16 md:py-24 bg-brand-beige" data-id="element-153">
      <div className="max-w-4xl mx-auto px-5 md:px-8" data-id="element-154">
        <div className="text-center mb-16" data-id="element-155">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-dark" data-id="element-156">
            Como Funciona
          </h2>
        </div>

        <div className="relative border-l-2 border-brand-sage-dark/30 ml-4 md:ml-8 space-y-12" data-id="element-157">
          {phases.map((phase, index) => <div key={index} className="relative pl-8 md:pl-12" data-id="element-158">
              <div className="absolute -left-[17px] top-1 w-8 h-8 bg-brand-dark rounded-full flex items-center justify-center text-white font-serif font-bold text-sm shadow-md border-4 border-brand-beige" data-id="element-159">
                {index + 1}
              </div>
              <div className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-brand-sage/20" data-id="element-160">
                <h3 className="text-xl font-bold text-brand-dark mb-3 font-serif" data-id="element-161">
                  {phase.title}
                </h3>
                <p className="text-brand-text/80 leading-relaxed" data-id="element-162">
                  {phase.text}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}